module.exports = __webpack_public_path__ + "img/9.7972fc9a.png";